<template>
  <div v-if="$store.state.userData">
    <!--Stats cards-->
    <div class="row">
      <div class="col-sm-6">
        <stats-card>
          <div class="icon-big text-center icon-success" slot="header">
            <i class="ti-wallet"></i>
          </div>
          <div class="numbers" slot="content">
            <p>Total Balance</p>
            {{($store.state.userData.total ? (Math.round($store.state.userData.total * 100) / 100) : 0)
                    .toLocaleString('en-US', { style: 'currency', currency: 'USD' })}}
          </div>
          <div class="stats" slot="footer">
            As of {{ moment(getYesterday()).format('MMMM D, YYYY') }},
            pending investment gains/losses posted at month end
          </div>
        </stats-card>
      </div>
      <div class="col-sm-6">
        <stats-card>
          <div class="icon-big text-center icon-success" slot="header">
            <i class="ti-stats-up"></i>
          </div>
          <div class="numbers" slot="content">
            <p>Total Earnings</p>
            {{ (Math.round(parseFloat($store.state.userData.marketSum[$store.state.userData.marketSum.length - 1].y) * 100) / 100)
              .toLocaleString('en-US', { style: 'currency', currency: 'USD' })}}
          </div>
          <div class="stats" slot="footer">
            <!-- *Tribe-specific  -->
            Since Enrollment or Transfer
          </div>
        </stats-card>
      </div>
    </div>
    <div class="row" v-if="$store.state.userData.assetAllocations.length > 0 && hasRecentTransaction">
      <div class="col-sm-6">
        <div class="card">
          <div class="card-content">
              <div class="row">
                <div class="pull-left col-xs-12" style="font-size: 1.5em">
                  Asset Allocation
                </div>
              </div>
            <slot name="subtitle"></slot>
            <div class="row">
              <div class="col-sm-7">
                <div id="assetAllocation" class="ct-chart ct-chart-pie"></div>
              </div>
              <div class="col-sm-5" id="assetAllocationLegend">

              </div>
            </div>
          </div>
          <div class="card-footer stats">
            <hr>
            As of {{ moment($store.state.userData.assetAllocations[0].Date).format('MMMM D, YYYY') }}
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="card">
          <div class="card-content">
            <div class="row">
              <div class="col-xs-12">
                <div class="pull-left" style="font-size: 1.5em; padding-left: 15px;">
                  Fund Investment Performance
                </div>
              </div>
            </div>
            <el-table class="table-striped" :data="$store.state.userData.investmentReturns">
              <el-table-column label="Time Period" min-width="200" property="Period"></el-table-column>
              <el-table-column label="Gain/Loss" width="100" property="Return" align="right" :formatter="(row,col,cell) => cell + '%'"></el-table-column>
              <el-table-column label=" " width="10"></el-table-column>
            </el-table>
          </div>
          <div class="card-footer stats">
            As of {{ moment($store.state.userData.investmentReturns[0].Date).format('MMMM D, YYYY') }}
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="$store.state.userData.market.length > 0">
        <div class="col-sm-6">
          <chart-card :chart-data="balanceChart.data" :chart-options="balanceChart.options">
            <span slot="title">
              Balance History
            </span>
            <span slot="title-label">
              <el-select
                class="select-success"
                size="small"
                v-model="chartRange"
                @change="updateChartRange($event)">
                <el-option
                  v-for="item in chartRanges"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </span>
            <h6 slot="subtitle"  v-html="chartTimeframe">

            </h6>
          </chart-card>
        </div>
        <div class="col-sm-6">
          <chart-card :chart-data="earningsChart.data" :chart-options="earningsChart.options">
            <span slot="title">
              Earnings History
            </span>
            <span slot="title-label">
              <el-select
                class="select-success"
                size="small"
                v-model="chartRange"
                @change="updateChartRange($event)">
                <el-option
                  v-for="item in chartRanges"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </span>
            <h6 slot="subtitle" v-html="chartTimeframe">

            </h6>
          </chart-card>
        </div>
    </div>
  </div>
</template>
<script>
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
  import Chartist from 'chartist'
  import 'chartist-plugin-legend'
  import swal from 'sweetalert2'

  export default {
    components: {
      StatsCard,
      ChartCard
    },
    methods: {
      updateChartRange (newRange) {
        let earningsSelected = []
        let transactionsSelected = []
        switch (newRange) {
          case 'all':
            earningsSelected = this.$store.state.userData.marketSum
            transactionsSelected = this.$store.state.userData.transactionsSum
            this.chartTimeframe = '<span class="text-muted">Since</span> account opened'
            break
          case '12months':
            earningsSelected = this.$store.state.userData.marketSum
              .filter((transaction) => transaction.x.isAfter(this.moment().subtract(12, 'months')))
            transactionsSelected = this.$store.state.userData.transactionsSum
              .filter((transaction) => transaction.x.isAfter(this.moment().subtract(12, 'months')))
            this.chartTimeframe = '<span class="text-muted">Over the</span> last 12 months'
            break
          case '3months':
            earningsSelected = this.$store.state.userData.marketSum
              .filter((transaction) => transaction.x.isAfter(this.moment().subtract(3, 'months')))
            transactionsSelected = this.$store.state.userData.transactionsSum
              .filter((transaction) => transaction.x.isAfter(this.moment().subtract(3, 'months')))
            this.chartTimeframe = '<span class="text-muted">Over the</span> last 3 months'
            break
        }

        this.earningsChart.data = {
          series: [
            earningsSelected
          ]
        }
        this.balanceChart.data = {
          series: [
            transactionsSelected
          ]
        }
      },
      getYesterday () {
        var yesterday = new Date()
        yesterday.setDate(yesterday.getDate() - 1)
        return yesterday
      }
    },
    mounted () {
      var legendSpace = document.getElementById('assetAllocationLegend')
      if (legendSpace) {
        Chartist.Pie('#assetAllocation', {
          labels: this.$store.state.userData.assetAllocations.map(
            (asset) => asset.Category + ' - ' + asset.Percent + '%'),
          series: this.$store.state.userData.assetAllocations.map(
            (asset) => asset.Percent)
        }, {
          showLabel: false,
          height: '210px',
        // labelDirection: 'explode'
          plugins: [
            Chartist.plugins.legend({
              clickable: false,
              position: legendSpace
            })
          ]
        })
      }
      // 0000398: SRP-MIC Online Project - for now, only show the all option for SRP-MIC
      if (!this.hasRecentTransaction) {
        this.chartRange = 'all'
        this.chartRanges = [{
          value: 'all',
          label: 'All Time'
        }]
        this.updateChartRange(this.chartRange)
      }
      if (this.$store.state.userData.UserId) {
        swal({
          title: `Welcome!`,
          text: 'You\'ve successfully logged in! Your User ID is ' + this.$store.state.userData.UserId + ', you can log in directly with it next time.',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'success'
        })
        delete this.$store.state.userData.UserId
      }
    },
    data () {
      return {
        chartRanges: [{
          value: 'all',
          label: 'All Time'
        }, {
          value: '12months',
          label: '12 Months'
        }, {
          value: '3months',
          label: '3 Months'
        }],
        chartRange: '12months',
        chartTimeframe: '<span class="text-muted">Over the</span> last 12 months',
        hasRecentTransaction: this.$store.state.userData.marketSum.length > 0
        ? this.$store.state.userData.marketSum[this.$store.state.userData.marketSum.length - 1].x
          .isAfter(this.moment().subtract(4, 'months')) : false, // Has an MK in the past 4 months (active account)
        earningsChart: {
          data: {
            series: [
              this.$store.state.userData.marketSum
              .filter((transaction) => {
                return transaction.x.isAfter(this.moment().subtract(12, 'months'))
              })
            ]
          },
          options: {
            showPoint: false,
            lineSmooth: true,
            height: '210px',
            axisX: {
              showGrid: true,
              showLabel: true,
              type: Chartist.FixedScaleAxis,
              divisor: 4,
              labelInterpolationFnc: (value) => {
                return this.moment(value).format('MMM D, YYYY')
              }
            },
            axisY: {
              offset: 60,
              showGrid: true,
              labelInterpolationFnc: (value) => {
                return (Math.round(parseFloat(value) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }).slice(0, -3)
              }
            },
            low: 'auto',
            high: 'auto',
            classNames: {
              line: 'ct-line ct-green'
            }
          }
        },
        balanceChart: {
          data: {
            series: [
              this.$store.state.userData.transactionsSum
              .filter((transaction) => {
                return transaction.x.isAfter(this.moment().subtract(12, 'months'))
              })
            ]
          },
          options: {
            showPoint: false,
            lineSmooth: Chartist.Interpolation.step(),
            height: '210px',
            axisX: {
              showGrid: true,
              showLabel: true,
              type: Chartist.FixedScaleAxis,
              divisor: 4,
              labelInterpolationFnc: (value) => {
                return this.moment(value).format('MMM D, YYYY')
              }
            },
            axisY: {
              offset: 60,
              showGrid: true,
              labelInterpolationFnc: (value) => {
                return (Math.round(parseFloat(value) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }).slice(0, -3)
              }
            },
            low: 'auto',
            high: 'auto',
            classNames: {
              line: 'ct-line ct-blue'
            }
          }
        }
      }
    }
  }
</script>
<style>
.el-input__inner {
  background-color: #fff;
  border-color: #7a9e9f !important;
  border-width: 2px;
  border-radius: 20px;
  color: #7a9e9f;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dashboard/Overview.vue